import * as React from "react";
import { Link } from "@/components/common/Link";
import { Linkedin, Twitter, MessageCircle as WhatsApp } from "lucide-react";
const legalLinks = [{
  label: "AVISO LEGAL",
  href: "#"
}, {
  label: "PRIVACIDAD",
  href: "#"
}, {
  label: "COOKIES",
  href: "#"
}];
const socialLinks = [{
  icon: Twitter,
  href: "https://twitter.com/recla360",
  label: "X (Twitter)"
}, {
  icon: Linkedin,
  href: "https://linkedin.com/company/recla360",
  label: "LinkedIn"
}, {
  icon: WhatsApp,
  href: "https://wa.me/34602505574?text=Hola,%20quiero%20información%20sobre%20cómo%20conseguir%20más%20clientes%20para%20mi%20negocio",
  label: "CONTACTAR POR WHATSAPP"
}];
export default function Footer() {
  return <footer data-section-id="174004" id="pie-de-página" className="dark bg-background text-foreground relative w-full border-t-2 border-muted py-16 md:py-20 lg:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[image:radial-gradient(var(--color-muted-foreground)_1px,transparent_1px)] bg-[size:24px_24px] opacity-5" />

      <div className="container mx-auto px-6 md:px-8 relative z-10 flex flex-col md:flex-row justify-between items-center gap-12 md:gap-16">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16">
          {}
          <ul className="flex items-center gap-6 text-sm uppercase font-sans tracking-[0.2em] text-muted-foreground">
            {legalLinks.map((link, i) => <li key={i} data-index={i} className="flex items-center gap-6">
                <Link to={link.href} className="hover:text-primary transition-colors duration-300">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="text-muted/50 select-none">|</span>}
              </li>)}
          </ul>

          {}
          <div className="flex items-center gap-8">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            const isWhatsApp = social.label === "WhatsApp";
            return <Link key={i} data-index={i} to={social.href} aria-label={social.label} newTab className={`transition-all duration-300 group flex items-center gap-3 ${isWhatsApp ? "text-[#25D366] hover:text-[#25D366]/80" : "text-muted-foreground hover:text-primary"}`}>
                  <Icon className="size-6 rotate-15 transition-transform duration-300 group-hover:rotate-0 group-hover:scale-110" strokeWidth={1.5} />
                  {isWhatsApp && <span className="text-xs font-sans font-bold uppercase tracking-wider whitespace-nowrap">
                      Contactar por WhatsApp
                    </span>}
                </Link>;
          })}
          </div>
        </div>

        {}
        <div className="shrink-0">
          <Link to="/HomePage" className="block transition-all hover:opacity-80 hover:scale-105">
            <div className="flex flex-col items-center md:items-end font-sans font-bold text-2xl md:text-3xl tracking-tighter">
              <span className="text-white">recla360.com</span>
              <div className="h-1 w-12 bg-linear-to-r from-primary to-blue-400 rounded-lg mt-1" />
            </div>
          </Link>
        </div>
      </div>
    </footer>;
}